import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Script } from 'gatsby';
import { InitInsights } from '@repo/utils/algoliaAnalytics';
import Head from '@repo/ui-components/Head';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';
import NotificationBanner from '@repo/ui-components/notification-banner/NotificationBanner';
import { MavenoidChatButton } from '@repo/ui-components/openChatWidget';
import Header from '@repo/ui-components/header/Header';
import Footer from '@components/footer/Footer';
import theme from '@components/theme';
import Menu from '@components/layout/Menu.json';
import getInternalLink from '@repo/utils/getInternalLink';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'lite-youtube-embed/src/lite-yt-embed.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'sportdog/src/styles/globals.css';
import '@utils/globals.css';

InitInsights();

const NO_SCRIPT_TAGS: JSX.Element[] = [];

interface LayoutProps {
  children?: React.ReactNode;
  scriptsData?: JSX.Element[];
  fullWidth?: boolean;
}

const Layout = ({
  children,
  scriptsData = NO_SCRIPT_TAGS,
  fullWidth = false,
}: Readonly<LayoutProps>) => {
  return (
    <ThemeProvider theme={theme}>
      <Head scriptTags={scriptsData} />
      <NotificationBanner
        messageText=""
        messageLink={null}
        ChatComponent={MavenoidChatButton}
        sticky={false}
        getInternalLink={getInternalLink}
        hasDealerSearch={false}
        hideFromScreenReader={false}
      />
      <Header
        menuStructure={Menu.menuSections}
        searchIndexes={['sportdog-support-articles', 'sportdog-support-pages']}
        showUtilityIcons={false}
      />
      <PageWrapper $fullWidth={fullWidth} $background="inherit" $padding="0">
        <main>{children}</main>
      </PageWrapper>
      <Footer />
      <Script
        async
        id="fontawesome-kit"
        src="https://kit.fontawesome.com/4dd77ed7cb.js"
      />
      <Script id="mavenoid-embed" strategy="post-hydrate">
        {`
          (function (m, a, v, e, n, o, i, d) {
            d = m.createElement(a);
            d.async = true;
            d.src =    "https://widget-hosts.mavenoid.com/custom-embedding-scripts/" + n + ".js";
            i = m.getElementsByTagName(a)[0];
            i.parentNode.insertBefore(d, i);
            v[e] = v[e] || [];
          })(document, "script", window, "mavenoid", "radio-systems-corp");
        `}
      </Script>
      {process.env.GATSBY_COOKIEPRO_SITE_ID && [
        <Script
          key="otSDKStub"
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          data-domain-script={process.env.GATSBY_COOKIEPRO_SITE_ID}
        />,
      ]}
    </ThemeProvider>
  );
};

export default Layout;
